import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { retryUnlessNotFound } from "@packages/core-client/query/retryUnlessNotFound.ts";
import { useQuery } from "@tanstack/react-query";
import { useMatches } from "react-router";
import { useDirectoryClient } from "../../../api/queries/directory.ts";

export function useIsProfileTabsPending() {
    const matches = useMatches();
    const personId = matches[matches.length - 1]?.params?.personId ?? "";

    const { queryUtils } = useDirectoryClient();
    const { isPending } = useQuery(
        createQueryOptions(queryUtils.getProfile.queryOptions({ input: { personId } }), {
            throwOnError: false,
            retry: retryUnlessNotFound
        })
    );

    return isPending;
}
